import React, { useEffect, useMemo, useState } from 'react';
import useDidMountEffect from '../../../../../../customHooks/useDidMountEffect';
import {
  getFormBody,
  getMandatoryFields,
  getValidationErrors,
} from '../../../utils/userOnboarding/userOnboarding.util';
import { isEmpty, isEqual } from 'lodash';
import { Box } from '@mui/material';
import ActionHeader from '../../../ActionHeader/ActionHeader';
import FormEdit from '../../../../common/Form/FormEdit';
import { showToast } from '../../../../../../utils/common.util';
import {
  FormFieldTypes,
  LoadingStatus,
  toastMessage,
  ToastThemes,
} from '../../../../../../constants/common';
import CircularLoader from '../../../../../../atoms/CircularLoader/circular-loader';
import { useSelector } from 'react-redux';
import {
  stringSubstitute,
  ToastMessages,
} from '../../../constants/onboarding.constants';
import { FormServices } from '../../../../../../services/formConfig';
import { preventKeyPressWithoutDecimal } from '../../../../../forms/claim-form-render/add-form-data/unergizer-claim-form/utils/unergizer-utils';

const PaycycleFormEdit = (props) => {
  const {
    setViewMode,
    formConfig,
    isNew,
    formData,
    setShowForm,
    payCycleId,
    setPayCycleId,
    moduleId,
  } = props;

  const [validationErrors, setValidationErrors] = useState({});
  const [formInfo, setFormInfo] = useState(formData || {});
  const [loading, setLoading] = useState(-1);

  const [disabledSave, setDisabledSave] = useState(true);
  const { currentUserRoleId } = useSelector((state) => state.main);

  useEffect(() => {
    setFormInfo(formData);
  }, [formData]);

  useDidMountEffect(() => {
    setDisabledSave(false);
  }, [formInfo]);

  const formFields = useMemo(() => {
    return formConfig.reduce((acc, item) => {
      const { fieldRefName } = item;
      let temp = { ...item };
      switch (fieldRefName) {
        case 'var_value':
          if (
            (typeof formInfo.value_data_type === 'object' &&
              formInfo.value_data_type !== null &&
              'name' in formInfo.value_data_type &&
              formInfo.value_data_type.name === 'BOOLEAN') ||
            (typeof formInfo.value_data_type !== 'object' &&
              formInfo.value_data_type === 'BOOLEAN')
          ) {
            temp = {
              ...temp,
              placeholderText: 'Select Option',
              fieldType: FormFieldTypes.SingleSelect,
            };
          } else if (
            (typeof formInfo.value_data_type === 'object' &&
              formInfo.value_data_type !== null &&
              'name' in formInfo.value_data_type &&
              formInfo.value_data_type.name === 'NUM') ||
            (typeof formInfo.value_data_type !== 'object' &&
              formInfo.value_data_type === 'NUM')
          ) {
            temp = {
              ...temp,
              fieldType: FormFieldTypes.Text,
              dataType: FormFieldTypes.Number,
            };
          } else if (
            (typeof formInfo.value_data_type === 'object' &&
              formInfo.value_data_type !== null &&
              'name' in formInfo.value_data_type &&
              formInfo.value_data_type.name === 'INT') ||
            (typeof formInfo.value_data_type !== 'object' &&
              formInfo.value_data_type === 'INT')
          ) {
            temp = {
              ...temp,
              fieldType: FormFieldTypes.Text,
              dataType: FormFieldTypes.Number,
              onKeyDown: preventKeyPressWithoutDecimal,
            };
          }
          break;
        default: {
          break;
        }
      }
      if (!temp.isHidden) {
        acc.push(temp);
      }
      if (temp.isHidden) {
        delete formInfo[temp?.fieldRefName];
      }
      return acc;
    }, []);
  }, [formConfig, formInfo]);

  const handleDiscard = () => {
    if (isNew) {
      setShowForm(false);
    } else {
      setViewMode(true);
    }
  };

  const requiredFields = useMemo(() => {
    return getMandatoryFields(formConfig);
  }, [formConfig]);

  const handleSave = async () => {
    const errors = getValidationErrors(formInfo, requiredFields);
    if (isEmpty(errors)) {
      setLoading(LoadingStatus.Loading);
      const body = getFormBody(formInfo);
      try {
        const res = await new FormServices().postOrgConfig(
          { ...body, moduleId: moduleId },
          currentUserRoleId
        );
        setPayCycleId(res.id);

        showToast(
          ToastMessages.success.replace(stringSubstitute, toastMessage.update),
          ToastThemes.success
        );

        const data = await new FormServices().getOrgConfigDetail(res.id);
        setFormInfo(data);

        setViewMode(true);
        setLoading(LoadingStatus.Success);
      } catch (err) {
        showToast(
          err?.response?.data?.message || 'Something Went Wrong',
          ToastThemes.error
        );
        setLoading(LoadingStatus.Failure);
        console.error(err?.response?.data?.message || err);
        throw err?.response?.data?.message;
      }
    } else {
      setValidationErrors(errors);
    }
  };

  const getDropdownOptions = (name) => {
    switch (name) {
      case 'value_data_type': {
        return [
          { id: 'BOOLEAN', name: 'BOOLEAN' },
          { id: 'STRING', name: 'STRING' },
          { id: 'NUM', name: 'NUM' },
          { id: 'INT', name: 'INT' },
        ];
      }
      case 'var_value': {
        return [
          { id: 'TRUE', name: 'TRUE' },
          { id: 'FALSE', name: 'FALSE' },
        ];
      }
    }
  };
console.log(formFields);
  return (
    <Box>
      <CircularLoader show={loading === LoadingStatus.Loading && payCycleId} />
      <Box mb={3} mx={-3} mt={-3}>
        <ActionHeader
          labelText={formData?.var_name || 'New Config'}
          showDiscard
          showPublish
          showPublishModal={false}
          publishButtonText="Save"
          onPublishClick={handleSave}
          onClickDiscard={handleDiscard}
          showSave={false}
          disabledPublish={disabledSave}
        />
      </Box>
      <FormEdit
        list={formFields}
        formInfo={formInfo}
        setFormData={setFormInfo}
        errors={validationErrors}
        setErrors={setValidationErrors}
        getDropdownOptions={getDropdownOptions}
      />
    </Box>
  );
};

export default PaycycleFormEdit;
